// extracted by mini-css-extract-plugin
export default {"wrapper":"spinner_wrapper__ore4J","rotate":"spinner_rotate__gN4RJ","circle":"spinner_circle__GVJOn","dash":"spinner_dash__2fNUP"};